"use strict";

var clicks = 0;

function addSecondaryFirmInput() {
  clicks = clicks + 1;
  event.preventDefault();
  var wrapper = $('.js-secondary-firms');
  var div = '<div class="input-secondary form-group js-form-group prl rel" data-error="secondary_law_firm">' + '<input class="Input has-icon-right js-secondary-firm" type="text" autocomplete="off" name="" id="secondary_law_firm_' + clicks + '" data-id="" value="">' + '<ul class="Search__results blog"></ul>' + '<a class="js-delete-firm" href="javascript:void(0)">' + '<img class="delete-firm" src="/static/svg/private/close-icon.svg" title="Delete">' + '</a>' + '</div>';
  wrapper.append(div);
  $('.js-secondary-firm').initSecondaryFirm();
  vueAccount.inputChange();
  vueAccount.deleteSecondaryFirm();
}

function addBar() {
  clicks = clicks + 1;
  event.preventDefault();
  var wrapper = $('.js-bar-wrapper');
  var div = '<div class="row js-row-bar" v-for="bar in lawyer.bars_obj">' + '<div class="col-lg-6 js-bar">' + '<div class="form-group js-form-group mbs rel full-w" data-error="bars">' + '<div class="rel">' + '<input class="Input has-icon-right js-input-bar" type="text" id="secondary_law_firm_' + clicks + '" data-id="" value="" autocomplete="off">' + '<ul class="Search__results blog"></ul>' + '</div>' + '</div>' + '</div>' + '<div class="col-lg-6 js-court">' + '<div class="form-group js-form-group mbs rel prl">' + '<input id="" type="text" class="Input js-court-input" name="" value="" disabled/>' + '<a class="js-delete-bar" href="javascript:void(0)">' + '<img class="delete-firm" src="/static/svg/private/close-icon.svg" title="Delete">' + '</a>' + '</div>' + '</div>' + '</div>';
  wrapper.append(div);
  $('.js-input-bar').initBar();
  vueAccount.inputChange();
  vueAccount.deleteBar();
}

function addClub(event) {
  event.preventDefault();
  var wrapper = $('.js-clubs-wrapper'),
      loops = $('.js-loop-clubs').data('loop'),
      div = '<div class="club-wrapper rel prxl mts">' + '<div class="Dropsel--container js-dropsel-container dropsel-lang">' + '<select name="club" class="Input Dropsel--select js-select js-clubs" required="" id="club">' + loops + '</select>' + '<button type="button" class="Input Dropsel--btn js-dropsel-btn"></button>' + '<ul class="Dropsel js-dropsel"></ul>' + '</div>' + '<a class="js-delete-club" :data-id="club.id" href="javascript:void(0)">' + '<img class="delete-club" src="/static/svg/private/close-icon.svg" title="Delete">' + '</a>' + '</div>';
  wrapper.append(div);
  initDropsels();
  $('.js-clubs').lawyerClubs();
  vueAccount.inputChange();
  vueAccount.deleteClub();
}

function addLawyerDegree() {
  var wrapper = $('.js-add-certificate'),
      div = '<div class="row row-degree js-degree js-new-degree" data-lawyer="' + window.user_id + '">' + '<div class="col-sm-6">' + '<div class="form-group js-form-group prs-lg" data-error="degree">' + '<input type="text" name="" id="" class="Input js-degree-name mbs" :value="degree.degree">' + '</div>' + '</div>' + '<div class="col-sm-3">' + '<div class="form-group js-form-group prs-lg">' + '<input type="date" name="certificate_year" id="certificate_year" class="Input js-degree-date" :value="degree.degree_date">' + '</div>' + '</div>' + '<div class="col-sm-2 rel">' + '<a class="js-delete-degree" href="javascript:void(0)">' + '<img class="delete-degree" src="/static/svg/private/close-icon.svg" title="Delete">' + '</a>' + '</div>' + '</div>';
  wrapper.append(div);
  vueAccount.inputChange();
  vueAccount.deleteDegree();
}

function addPostulation() {
  var wrapper = $('.js-postulations'),
      div = '<div class="rel postulation-wrapper form-group" data-error="name">' + '<div>' + '<input class="Input has-icon-right js-postulation js-new-postulation" data-lawyer="' + window.user_id + '" type="text" name="postulation" id="" value="" autocomplete="off">' + '</div>' + '<a class="js-delete-postulation" href="javascript:void(0)">' + '<img class="delete-postulation" src="/static/svg/private/close-icon.svg" title="Delete">' + '</a>' + '</div>';
  wrapper.append(div);
  vueAccount.inputChange();
  vueAccount.deletePostulation();
}

(function ($) {
  $.fn.addingElement = function () {
    var that = this;
    that.on('click', function (e) {
      e.preventDefault();
      var wrapper = $(this).prev();
    });
  };
})(jQuery);

$(function () {
  if ($('.js-btn-add').length) {
    $('.js-btn-add').addingElement();
  }
});